module.exports = __webpack_public_path__ + "98ed2c63f8ad218902245bc18ef21daf.png";